import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  grid: {
    ...theme.standarts('grid'),

    display: 'flex',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: '0%',
    flexDirection: 'column',
    gap: theme.get('grid', 'indent'),

    width: '100%',
    maxWidth: '100%'
  },

  container: {
    flexWrap: 'wrap',
    flexDirection: 'row'
  },

  grow: {
    flexGrow: (props) => props.grow
  },

  gap: {
    gap: (props) => theme.getFactor('grid', 'indent', props.gap)
  }
}));

const useVariantStyles = createUseStyles((theme) => ({}));

const useAlignStyles = createUseStyles((theme) => ({
  center: {
    alignItems: 'center'
  },

  start: {
    alignItems: 'flex-start'
  },

  end: {
    alignItems: 'flex-end'
  },

  stretch: {
    alignItems: 'stretch'
  },

  baseline: {
    alignItems: 'baseline'
  }
}));

const useJustifyContentStyles = createUseStyles((theme) => ({
  center: {
    justifyContent: 'center'
  },

  start: {
    justifyContent: 'flex-start'
  },

  end: {
    justifyContent: 'flex-end'
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles,
        align: useAlignStyles,
        justifyContent: useJustifyContentStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string,
      align: PropTypes.string,
      justifyContent: PropTypes.string,
      grow: PropTypes.number,
      gap: PropTypes.number
    };

    static defaultProps = {
      grow: 1
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        classes,
        children,
        container,
        variant,
        align,
        justifyContent,
        grow,
        gap,
        ...props
      } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.grid,
        container && classes.main.container,
        variant && classes.variant[variant],
        align && classes.align[align],
        justifyContent && classes.justifyContent[justifyContent],
        !container && grow !== 1 && classes.main.grow,
        container && (gap || gap === 0) && classes.main.gap
      );

      return (
        <div {...props} className={mergedClassName}>
          {children}
        </div>
      );
    }
  }
);
